
const plansFreeEnum = ["Beta Testers", "Plano Gratuito", "Simulação"];

export { plansFreeEnum }